import { render, staticRenderFns } from "./ListPackageRestriction.vue?vue&type=template&id=4d194641"
import script from "./ListPackageRestriction.vue?vue&type=script&lang=js"
export * from "./ListPackageRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports